import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
// Imported before App on purpose, and it must stay there. App pulls in
// qampo-ui-library, which runs its own i18next on import: it reads the language out of
// localStorage ("i18nextLng") exactly once, at module top level, and everything it
// formats by locale afterwards — InputFieldNumber's decimals, for one — reads that
// instance's language. Our detection writes that key, so it has to have run by then;
// imported after App, the write lands after the only read and the library formats
// English in a Danish UI for the rest of the session. Pinned by
// src/__tests__/i18nBootOrder.test.ts.
import './services/translations/translationService.ts';
import App from './App.tsx';
import { store } from './store/index.ts';
import 'qampo-ui-library/styles';
import './styles/index.css';
import './styles/variables.css';
import './styles/print.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);
